import {TransactionFilter} from "@/model/transaction-filter";
import {TransactionPreview} from "@/model/transaction-preview";
import {http} from "@/plugins/http";
import {LogElement} from "@/model/chatbot-log";
import {Page} from "@/model/page";
import {Message} from "@/model/message";
import {ChatbotSession} from "@/model/chatbot-session";

export const logService = new class LogService{

  get path (): string {
    return '/log/chatbot'
  }

  async getLogs (msisdn: string, startTime: number, endTime: number): Promise<LogElement[]> {
    return ((await http.get(this.path + '/', {
      params: {
        'msisdn': msisdn,
        'startTime': startTime,
        'endTime': endTime
      }
    })).data as any[]).map(a => Object.assign(new LogElement(),a))
  }

  async getContext(msisdn: string, brand: string, channel: string,entryPoint: string): Promise<any> {
    return (await http.get(this.path + '/session/context', {
      params: {
        'msisdn': msisdn,
        'brand': brand,
        'channel': channel,
        'entryPoint':entryPoint,
      }
    })).data
  }


  async getSessionPage (page: number, size: number): Promise<Page<ChatbotSession>> {
    return (await http.get(this.path + '/session', {
      params: {
        page: page,
        size: size
      }
    })).data
  }
}
